import { create } from 'zustand';
import { invitationsApi, OrganizationInvitation } from '../lib/organizations';

interface InvitationState {
  // 초대 목록
  invitations: OrganizationInvitation[];
  isLoading: boolean;
  error: string | null;

  // 모달 상태
  isModalOpen: boolean;

  // 액션
  fetchInvitations: () => Promise<void>;
  acceptInvitation: (token: string) => Promise<void>;
  rejectInvitation: (token: string) => Promise<void>;
  openModal: () => void;
  closeModal: () => void;
  clearError: () => void;
}

export const useInvitationStore = create<InvitationState>((set, get) => ({
  // 초기 상태
  invitations: [],
  isLoading: false,
  error: null,
  isModalOpen: false,

  // 초대 목록 조회
  fetchInvitations: async () => {
    set({ isLoading: true, error: null });
    try {
      const invitations = await invitationsApi.getMyInvitations();
      set({ invitations, isLoading: false });
    } catch (error) {
      set({
        error: error instanceof Error ? error.message : '초대 목록을 불러오는데 실패했습니다.',
        isLoading: false,
      });
    }
  },

  // 초대 수락
  acceptInvitation: async (token: string) => {
    set({ isLoading: true, error: null });
    try {
      await invitationsApi.accept(token);
      // 목록에서 제거
      const { invitations } = get();
      set({
        invitations: invitations.filter((inv) => inv.token !== token),
        isLoading: false,
      });
    } catch (error) {
      set({
        error: error instanceof Error ? error.message : '초대 수락에 실패했습니다.',
        isLoading: false,
      });
      throw error;
    }
  },

  // 초대 거절
  rejectInvitation: async (token: string) => {
    set({ isLoading: true, error: null });
    try {
      await invitationsApi.reject(token);
      // 목록에서 제거
      const { invitations } = get();
      set({
        invitations: invitations.filter((inv) => inv.token !== token),
        isLoading: false,
      });
    } catch (error) {
      set({
        error: error instanceof Error ? error.message : '초대 거절에 실패했습니다.',
        isLoading: false,
      });
      throw error;
    }
  },

  // 모달 열기/닫기
  openModal: () => set({ isModalOpen: true }),
  closeModal: () => set({ isModalOpen: false }),
  clearError: () => set({ error: null }),
}));
